import { ButtonProps, useChatContext } from '@copilotkit/react-ui';
import { Sparkle28Filled } from '@fluentui/react-icons';
import React from 'react';
import { useSelector } from 'react-redux';
import localeService from 'src/dataServices/LocaleService';
import { RootState } from 'src/state/reduxStore';

export const CustomCopilotButton: React.FC<ButtonProps> = () => {
  const { open, setOpen, icons } = useChatContext();

  // Re-render once localization content has loaded so the button text is populated
  // (on a cold load, e.g. incognito, locale text is not yet available on first render)
  useSelector((state: RootState) => state.locale.currentLocale);

  // Listen for hero bar send events to open the sidebar
  React.useEffect(() => {
    const handleHeroSend = () => setOpen(true);
    window.addEventListener('copilot-hero-send', handleHeroSend);
    return () => window.removeEventListener('copilot-hero-send', handleHeroSend);
  }, [setOpen]);

  return (
    <button
      type="button"
      className={`copilot-custom-button ${open ? 'open' : ''}`}
      aria-label={
        open
          ? localeService.getText('ContactUs', 'CustomCopilotHeaderCloseAriaLabel')
          : localeService.getText('ContactUs', 'CustomCopilotButtonOpenChatAriaLabel')
      }
      aria-expanded={open}
      onClick={() => setOpen(!open)}
    >
      <div className="copilot-custom-button-icon-container">
        <Sparkle28Filled className="copilot-custom-button-icon" />
      </div>
      <div className="copilot-custom-button-text">
        <span> {localeService.getText('ContactUs', 'CustomCopilotButtonNeedHelp')}</span>
        <span>{localeService.getText('ContactUs', 'CustomCopilotButtonLetsChatText')}</span>
      </div>
      {/* Close icon overlay when open */}
      <div className="copilot-custom-button-close">{icons.closeIcon}</div>
    </button>
  );
};

